import { lazy, Suspense } from 'react';
import { MonacoEditorProps } from '@uiw/react-monacoeditor';

// Lazy load the CodeEditor component to reduce initial bundle size (Monaco Editor is ~3.5MB)
const CodeEditorComponent = lazy(() => import('./CodeEditor').then(mod => ({ default: mod.CodeEditor })));

type PropsCodeEditor = {
  defaultLenguage?: string;
  defaultValue?: string;
  onChange?: (value) => void;
} & MonacoEditorProps;

// Fallback component while editor is loading
function CodeEditorFallback({ height = '70vh' }: { height?: string | number }) {
  return (
    <div 
      style={{ 
        width: '100%', 
        height: typeof height === 'number' ? `${height}px` : height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#1e1e1e',
        borderRadius: '4px',
        color: '#fff'
      }}
    >
      <div>
        <div className="spinner-border text-light mb-2" role="status">
          <span className="visually-hidden">Loading editor...</span>
        </div>
        <div style={{ fontSize: '14px', opacity: 0.7 }}>Loading code editor...</div>
      </div>
    </div>
  );
}

export function CodeEditorLazy(props: PropsCodeEditor) {
  return (
    <Suspense fallback={<CodeEditorFallback height={props.height} />}>
      <CodeEditorComponent {...props} />
    </Suspense>
  );
}

export default CodeEditorLazy;
